export default "__VITE_ASSET__7761fa18__"